module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-1x fa-fw"
  }), _vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51aeb2fe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-loading.vue
// module id = 104
// module chunks = 0